<template>
  <div class="page-header">
    <div class="page-header__body">
      <div class="content-center">
        <img class="longstron-logo" src="@/assets/img/layout/logo.png" alt="易隆创" />
        <div class="navigation-menu">
          <router-link to="/home">首页</router-link>
          <router-link to="/service">服务</router-link>
          <router-link to="/scheme">方案</router-link>
          <router-link to="/cooperation">合作</router-link>
        </div>
        <div class="user-info-wrapper">
          <!-- <i class="el-icon-phone"></i>
          <span>025-66678988</span> -->
          <div style="cursor: pointer;" v-if="!isLoggIn" @click="setLoginPopup(true)">登录</div>
          <el-dropdown @command="handleCommand" v-else>
            <div class="user-info-container">
              <img class="avatar" :src="avatar" alt="头像" v-if="avatar" />
              <img class="avatar" src="@/assets/img/icon_user.png" alt="头像" v-else />
              <span style="margin-left:8px;">{{ realname }}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentUser } from "@/api/home/home.js";
import { logout } from "@/api/home/login.js";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "page-header",
  data() {
    return {
      avatar: "", // 头像
      realname: "", // 真实姓名
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isLoggIn"]),
  },
  watch: {
    currentUser(newV) {
      this.avatar = newV?.headPortrait || "";
      this.realname = newV?.realname || "";
    },
  },
  mounted() {
    if (this.isLoggIn) {
      getCurrentUser().then((user) => {
        this.$store.dispatch("setCurrentUser", user?.model || null);
      });
    }
  },
  methods: {
    ...mapActions(['setLoginPopup']),
    handleCommand(command) {
      switch (command) {
        case 'logout':
          logout().then(() => {
            this.$store.dispatch('logout');
            if (this.$route.path !== '/home') this.$router.push('/home');
            this.$message.success('已退出登录！');
          });
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-header {
  width: 100%;
  max-width: @max-page-width;
  height: @header-height;
  .page-header__body {
    width: 100%;
    max-width: @max-page-width;
    height: @header-height;
    background-color: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
    position: fixed;
    top: 0;
    z-index: 100;
    .content-center {
      display: flex;
      align-items: center;
      .longstron-logo {
        width: 68px;
        height: 68px;
      }
      .navigation-menu {
        margin: 0 auto 0 160px;
        display: flex;
        a {
          color: @default-color;
          text-decoration: none;
          transition: color 0.3s ease;
          & + a {
            margin-left: 80px;
          }
          &:hover {
            color: @primary-color;
          }
          &.router-link-active {
            color: @primary-color;
          }
        }
      }
      .user-info-wrapper {
        display: flex;
        align-items: center;
        color: @primary-color;

        .user-info-container {
          display: flex;
          align-items: center;
          cursor: pointer;
          .avatar {
            width: 45px;
            height: 45px;
            border-radius: 50%;
          }
        }

        // .el-icon-phone {
        //   font-size: 20px;
        //   margin-right: 3px;
        // }
      }
    }
  }
}
</style>
